import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { EmmetEditorAction } from '../emmetActions.js';
import { registerEditorAction } from 'vscode/vscode/vs/editor/browser/editorExtensions';
import { EditorContextKeys } from 'vscode/vscode/vs/editor/common/editorContextKeys';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';

const _moduleId = "vs/workbench/contrib/emmet/browser/actions/expandAbbreviation";
class ExpandAbbreviationAction extends EmmetEditorAction {
    constructor() {
        super({
            id: 'editor.emmet.action.expandAbbreviation',
            label: ( localizeWithPath(_moduleId, 0, "Emmet: Expand Abbreviation")),
            alias: 'Emmet: Expand Abbreviation',
            precondition: EditorContextKeys.writable,
            actionName: 'expand_abbreviation',
            kbOpts: {
                primary: 2 ,
                kbExpr: ( (ContextKeyExpr.and(
                    EditorContextKeys.editorTextFocus,
                    EditorContextKeys.tabDoesNotMoveFocus,
                     (ContextKeyExpr.has('config.emmet.triggerExpansionOnTab'))
                ))),
                weight: 100
            },
            menuOpts: {
                menuId: MenuId.MenubarEditMenu,
                group: '5_insert',
                title: ( localizeWithPath(_moduleId, 1, "Emmet: E&&xpand Abbreviation")),
                order: 3
            }
        });
    }
}
registerEditorAction(ExpandAbbreviationAction);
